import React from 'react';
import { Outlet } from 'react-router-dom';
import './AdminLayout.css';

// Layout para las pantallas bajo /admin. Cuando se monta como ruta padre
// con children definidos en el router, usa <Outlet />. Cuando se monta
// directamente con children JSX (caso de rutas independientes que comparten
// el mismo chrome, p.ej. /admin/crear-encuesta para Vicepresidentes), usa
// los children pasados como prop.
export const AdminLayout = ({ children }) => {
  return (
    <div className="admin-layout">
      <div className="admin-content">
        {children || <Outlet />}
      </div>
    </div>
  );
};
